import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class AlertSuccess32Icon extends BaseIcon {
  getChildren = () => [
    <path d="M16 0a16 16 0 1016 16A16 16 0 0016 0zm7.74 10.68l-11 12A1 1 0 0112 23h-.08a1 1 0 01-.75-.45l-4-6a1 1 0 011.66-1.1l3.29 4.93L22.26 9.32a1 1 0 011.48 1.36z" fill="#56b40a"/>
    ]
  getViewBox = () => '0 0 32 32'
}
